// Constants for Spending Tracker

export const EXPENSE_CATEGORIES = [
	'Single Property Website',
	'Paid Listing Ad',
	'Listing Postcard',
	'Post-Close Postcard',
	'SOI Postcard',
	'Farm Postcard',
	'Specialty Mailer',
	'Event Mailer',
	'Booklet Design',
	'Booklet Mailer',
	'Specialty Design',
	'Digital Billboard',
	'Google Ad',
	'Client Gift',
	'Other',
];

export const VALIDATION_RULES = {
	name: {
		required: true,
		minLength: 3,
		maxLength: 100,
		message: 'Expense name must be 3-100 characters',
	},
	category: {
		required: true,
		enum: EXPENSE_CATEGORIES,
		message: 'Please select a valid category',
	},
	date: {
		required: true,
		format: /^\d{4}-\d{2}-\d{2}$/,
		message: 'Date must be in YYYY-MM-DD format',
	},
	amount: {
		required: true,
		min: 0.01,
		max: 999999.99,
		message: 'Amount must be between $0.01 and $999,999.99',
	},
	notes: {
		maxLength: 500,
		message: 'Notes cannot exceed 500 characters',
	},
};

// Currency formatter
export const formatCurrency = (amount) => {
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(amount);
};

// Date formatter
export const formatDate = (dateString) => {
	return new Date(dateString).toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});
};

// Generate month options for dropdown
export const generateMonthOptions = (monthsBack = 12) => {
	const months = [];
	const today = new Date();

	for (let i = 0; i < monthsBack; i++) {
		const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
		const value = date.toISOString().slice(0, 7); // "2025-09"
		const label = date.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
		});
		months.push({ value, label });
	}

	return months;
};

// Helper function to calculate category breakdown from expenses
export const getCategoryBreakdown = (expenses) => {
	const breakdown = {};
	let total = 0;

	expenses.forEach((expense) => {
		const amount = parseFloat(expense.amount || 0);
		if (!breakdown[expense.category]) {
			breakdown[expense.category] = 0;
		}
		breakdown[expense.category] += amount;
		total += amount;
	});

	return { breakdown, total };
};
